export default "__VITE_ASSET__hox71GEC__"